export const skillsData = [
  {
    category: "Programming Languages",
    iconName: "FaCode",
    color: "#00F2FE", // Cyan
    items: ["Python", "Pandas", "Matplotlib", "NumPy", "PySpark", "R", "JavaScript", "SQL"]
  },
  {
    category: "AI & Machine Learning",
    iconName: "FaBrain",
    color: "#9B51E0", // Purple
    items: [
      "Scikit-Learn", "PyTorch", "TensorFlow", "Transformers", "Deep Learning",
      "NLP (spaCy, NLTK)", "Computer Vision", "LLM Fine-Tuning", "Prompt Engineering",
      "RAG", "Embeddings", "Vector Databases"
    ]
  },
  {
    category: "Agents & Orchestration",
    iconName: "FaNetworkWired",
    color: "#00FF87", // Green
    items: ["LangChain", "LangGraph", "CrewAI", "MCP (Model Context Protocol)", "n8n", "Agent Architecture"]
  },
  {
    category: "APIs & Deployment",
    iconName: "FaServer",
    color: "#FF4500", // Red-orange
    items: ["FastAPI", "Django", "REST API Development", "Docker", "CI/CD", "MLflow", "DVC", "Railway", "Grafana"]
  },
  {
    category: "Cloud & Data Engineering",
    iconName: "FaCloud",
    color: "#1E90FF", // Blue
    items: ["Azure Machine Learning", "Azure AI Services", "Azure Databricks", "Apache Airflow", "dbt", "SSIS", "Data Pipelines"]
  },
  {
    category: "Analytics & BI",
    iconName: "FaChartBar",
    color: "#FFA500", // Orange
    items: ["Tableau", "Power BI", "Excel", "Statistics", "Web Scraping"]
  }
];
